import { Injectable } from '@angular/core';
import { Sport } from 'src/app/models/sports';
import { ApiOptions, ApiService } from 'src/app/core/services/api.service';

@Injectable()
export class SportsService {

  constructor(private api: ApiService) { }

  getSports(apiOptions?: ApiOptions) {

    return this.api.get<Sport[]>('sports', undefined, apiOptions);
  }

  getSport(id: number) {
    return this.api.get<Sport>(`sports/${id}`);
  }
}
